import { Typography } from '@material-ui/core';
function NotFound() {
    return (React.createElement("div", { className: "not-found" },
        React.createElement(Typography, { variant: "h6" }, "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430")));
}
export default NotFound;
